<template>
  <v-card
    flat
    class="pa-3 mt-2"
  >
    <v-card-text>
      <v-form
        ref="newClientForm"
        class="multi-col-validation mt-6"
        lazy-validation
        @submit.prevent="newClientHandler"
      >
        <v-row>
          <v-col
            md="6"
            cols="12"
          >
            <v-text-field
              v-model="accountDataLocale.name"
              label="Name"
              dense
              outlined
              :prepend-inner-icon="icons.mdiFormTextbox"
              :rules="newClientRules.nameRules"
            ></v-text-field>
          </v-col>

          <!-- removed on 11/26/2022 @JP -->
          <!-- added on 03/18/2026 @JP -->
          <v-col
            cols="12"
            md="6"
          >
            <v-select
              v-model="accountDataLocale.gender"
              dense
              outlined
              label="Gender"
              :items="genders"
              :prepend-inner-icon="icons.mdiGenderMaleFemale"
              :rules="newClientRules.anyRequired"
            ></v-select>
          </v-col>

          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="accountDataLocale.zipCode"
              label="ZIP Code"
              dense
              outlined
              :prepend-inner-icon="icons.mdiNumeric"
              :rules="newClientRules.zipRules"
            ></v-text-field>
          </v-col>

          <v-col
            cols="12"
            md="6"
          >
            <v-menu
              ref="menuActivePicker"
              v-model="menuActivePicker"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="accountDataLocale.birthday"
                  label="Date of Birth (DOB)"
                  :prepend-inner-icon="icons.mdiCalendar"
                  readonly
                  v-bind="attrs"
                  dense
                  outlined
                  :rules="newClientRules.anyRequired"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="accountDataLocale.birthday"
                :active-picker.sync="activePicker"
                :max="(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)"
                min="1900-01-01"
                @change="saveActivePicker"
              ></v-date-picker>
            </v-menu>
          </v-col>

          <v-col
            cols="12"
            md="6"
          >
            <v-select
              v-model="accountDataLocale.ethnicity"
              dense
              outlined
              label="Ethnicity"
              :items="ethnicitys"
              :prepend-inner-icon="icons.mdiHumanCapacityIncrease"
              :rules="newClientRules.anyRequired"
            ></v-select>
          </v-col>

          <v-col
            cols="12"
            md="6"
          >
            <v-select
              v-model="accountDataLocale.status"
              dense
              outlined
              label="Status"
              :items="statuses"
              :prepend-inner-icon="icons.mdiCellphoneLock"
              :rules="newClientRules.anyRequired"
              :disabled="action === 'new'"
            ></v-select>
          </v-col>

          <v-col cols="12">
            <v-checkbox
              v-if="action === 'new'"
              v-model="addVisit"
              label="Register today's visit to this account?"
              class="mt-0"
            ></v-checkbox>
          </v-col>

          <v-col cols="12">
            <v-btn
              color="primary"
              class="me-3 mt-4"
              :loading="isSaving"
              type="submit"
            >
              {{ action === 'new' ? 'Save account' : 'Update Account' }}
            </v-btn>
            <v-btn
              color="secondary"
              outlined
              class="mt-4"
              type="reset"
              @click.prevent="resetForm"
            >
              Cancel
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import {
  mdiAlertOutline,
  mdiCloudUploadOutline,
  mdiCalendar,
  mdiAccountOutline,
  mdiGenderMaleFemale,
  mdiNumeric,
  mdiHumanCapacityIncrease,
  mdiCellphoneLock,
  mdiFormTextbox,
} from '@mdi/js'
import { ref } from '@vue/composition-api'

import Swal from 'sweetalert2'
import { newClientRules } from '@/utils/form-rules'
import { axiosInst } from '@/utils/axiosIns'

export default {
  props: {
    accountData: {
      type: Object,
      required: true,
    },
    action: {
      type: String,
      required: true,
    },
    clientId: {
      type: String,
      default: '',
    },
  },

  setup(props) {
    const ethnicitys = ['American Indian or Alaska Native', 'Asian', 'Black or African American', 'Hispanic or Latino', 'Native Hawaiian or Other Pacific Islander', 'White', 'Other']
    const genders = ['Male', 'Female']
    const statuses = ['Active', 'Inactive']

    const accountDataLocale = ref(JSON.parse(JSON.stringify(props.accountData)))

    const resetForm = () => {
      accountDataLocale.value = JSON.parse(JSON.stringify(props.accountData))
    }

    const addVisit = ref(props.action === 'new')

    return {
      ethnicitys,
      accountDataLocale,
      resetForm,
      icons: {
        mdiAlertOutline,
        mdiCloudUploadOutline,
        mdiCalendar,
        mdiAccountOutline,
        mdiGenderMaleFemale,
        mdiNumeric,
        mdiHumanCapacityIncrease,
        mdiCellphoneLock,
        mdiFormTextbox,
      },
      genders,
      statuses,
      activePicker: null,
      menuActivePicker: false,
      newClientRules: newClientRules(),
      isSaving: false,
      addVisit,
    }
  },

  watch: {
    menuActivePicker(val) {
      if (val) {
        setTimeout(() => {
          this.activePicker = 'YEAR'
        })
      }
    },

    /*
    action(val, oldVal) {
      console.log('action:', val, oldVal)
    },
    */

    accountData(val) {
      this.accountDataLocale = JSON.parse(JSON.stringify(val))
    },
  },

  mounted() {
    // setTimeout(() => this.$emit('new-client-done', '62bca308763a5827e333b91e'), 2000)
  },

  methods: {
    saveActivePicker(date) {
      this.$refs.menuActivePicker.save(date)
    },

    async newClientHandler() {
      if (!this.$refs.newClientForm.validate()) return

      this.isSaving = true

      try {
        const endPoint = this.action === 'new' ? 'new-client' : 'client-update'
        const backendAction = this.action === 'new' ? 'new' : 'account'
        const actionMsg = this.action === 'new' ? 'saved' : 'updated'

        const rs = await axiosInst.post(endPoint, {
          action: backendAction,
          clientId: this.clientId,
          name: this.accountDataLocale.name,
          gender: this.accountDataLocale.gender,
          zipCode: this.accountDataLocale.zipCode,
          birthday: this.accountDataLocale.birthday,
          ethnicity: this.accountDataLocale.ethnicity,
          status: this.accountDataLocale.status,
        })

        // console.log(rs)
        if (rs.status === 200 && rs.data.error === false) {
          const newClientId = rs.data.newClientId || undefined
          if (this.action === 'new' && newClientId) this.$emit('new-client-done', { newClientId, addVisit: this.addVisit })

          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: `Account has been ${actionMsg}`,
            showConfirmButton: false,
            timer: 1500,
          })
        }
      } catch (err) {
        // console.error('error:', err)
        Swal.fire('Error while saving the account', err.response?.data?.r || 'An error occurred while saving the account.', 'error')
      } finally {
        this.isSaving = false
      }
    },
  },
}
</script>
